
import {Component, Prop, Vue} from 'vue-property-decorator'
import {currency} from '../utils/format'
import Payment from '@/checkout/models/Payment'

@Component({})
export default class CheckoutSummary extends Vue {
  @Prop() readonly payment?: Payment

  get orderAmount(): number {
    return this.payment?.amount ?? 0
  }

  get customerFee(): number {
    return 0
  }

  get totalAmount(): number {
    return this.orderAmount + this.customerFee
  }

  get formattedOrderAmount(): string {
    return currency(this.orderAmount, this.payment?.asset)
  }

  get formattedCustomerFee(): string {
    return currency(this.customerFee, this.payment?.asset)
  }

  get formattedTotalAmount(): string {
    return currency(this.totalAmount, this.payment?.asset)
  }

  get ariaLabel(): string {
    return this.$t('message.paymentSummary').toString()
  }
}
